module.exports = __webpack_public_path__ + "img/logo_dark@3x.68e794d9.png";